var ValueJS = ValueJS || {};

ValueJS.FixedHeader = function() {

    var _header = $('header');
    var _hero = $('.section--hero');

    var _window = $(window);
    var _heroHeight = _hero.height() || 1;
    var _headerHeight = _header.height() || 0;
    var _oldScrollPosition = _window[0].pageYOffset;

    var _init = function() {
        _update();
        _window.on('scroll', _update);
    }

    var _update = function() {
        if (_hasScrolledDown()) {
            if (_scrolledPastHero()) {
                _header.addClass('header--hide');
            }
        } else {
            _header.removeClass('header--hide');
            // if (_scrolledPastHero()) {
            //     _header.addClass('header--bg');
            // } else {
            //     _header.removeClass('header--bg');
            // }
        }
        _oldScrollPosition = _window[0].pageYOffset;
    }

    var _scrolledPastHero = function() {
        return _window.scrollTop() > (_heroHeight - _headerHeight);
    }

    var _hasScrolledDown = function() {
        return _window[0].pageYOffset > _oldScrollPosition;
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.FixedHeader.init();
});
